<template>
  <div class="notFound">
    <div class="info">
      <h1>404 Not Found</h1>
      <p class="p-info">We already searching until lost in this forest, but nothing found.</p>
      <p class="p-info">Let's go back before getting darker!</p>
      <button @click="goHome()" class="btn btn-outline-light">Go Home</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
  .btn {
    margin-top: 10px;
  }
  .p-info {
    margin-bottom: 2px;
  }
  .notFound{
    position: absolute;
    width: 100%;
    min-height: 90vh;
    background-image: url('../assets/404.jpg');
    background-size: cover;
  }
  .info {
    margin: 0;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-shadow: 2px 2px black;
    color: white;
  }
</style>
